import './index.scss';

export type MonogramSize = 'medium' | 'large';

export default function Monogram(props: {
  name: string;
  size?: MonogramSize;
}) {
  const size = props.size ?? 'medium';
  const className = `monogram monogram-${size} monogram-${monogramColorForName(props.name)}`;

  return (
    <div className={className}>
      <span>{monogramForName(props.name)}</span>
    </div>
  );
}

function monogramForName(name: string) {
  const initials = name.split(' ').map((word) => word[0]).join('');

  return initials.length > 2 ? initials.substring(0, 2) : initials;
}

// Matches the class names in index.scss, in the same order as the iOS palette.
const MONOGRAM_COLORS = [
  'red', 'orange', 'green', 'blue', 'purple', 'pink', 'cyan', 'indigo', 'mint', 'teal'
];

// A name always lands on the same color. Written out rather than using a
// built-in hash so the value is stable across sessions and browsers.
export function monogramColorForName(name: string) {
  let hash = 0;

  for (let index = 0; index < name.length; index++) {
    hash = ((hash * 31) + name.charCodeAt(index)) | 0;
  }

  return MONOGRAM_COLORS[Math.abs(hash) % MONOGRAM_COLORS.length];
}
